document.addEventListener( 'DOMContentLoaded', () => {
	const MOBILE_BP    = 1024;
	const AUTO_DELAY   = 6000;

	document.querySelectorAll( '.hero' ).forEach( ( hero ) => {
		const nav      = hero.querySelector( '.hero__slider' );
		const navItems = hero.querySelectorAll( '.hero__slider-item' );
		const slides   = hero.querySelectorAll( '.hero__slide' );
		const bgs      = hero.querySelectorAll( '.hero__slide-bg' );

		// Mobile elements
		const mobileNav   = hero.querySelector( '.hero__mobile-nav' );
		const mobileLabel = hero.querySelector( '.hero__mobile-label' );
		const mobileDots  = hero.querySelectorAll( '.hero__mobile-dot' );

		// ── Cover-video pause/play toggle (WCAG 2.2.2) ────────────────────
		const videoToggle = hero.querySelector( '.hero__video-toggle' );
		if ( videoToggle ) {
			const coverVideo = hero.querySelector( '.hero__slide-bg video' );
			if ( coverVideo ) {
				videoToggle.addEventListener( 'click', () => {
					const pauseIcon = videoToggle.querySelector( '.hero__video-toggle-icon--pause' );
					const playIcon  = videoToggle.querySelector( '.hero__video-toggle-icon--play' );
					if ( coverVideo.paused ) {
						coverVideo.play().catch( () => {} );
						pauseIcon.hidden = false;
						playIcon.hidden  = true;
						videoToggle.setAttribute( 'aria-label', videoToggle.getAttribute( 'data-pause-label' ) || 'Pause background video' );
					} else {
						coverVideo.pause();
						pauseIcon.hidden = true;
						playIcon.hidden  = false;
						videoToggle.setAttribute( 'aria-label', videoToggle.getAttribute( 'data-play-label' ) || 'Play background video' );
					}
				} );
			}
		}

		if ( ! navItems.length ) return;

		let currentIndex = 0;
		let autoTimer    = null;

		// ── Follower pill ──────────────────────────────────────────────────

		const follower = document.createElement( 'span' );
		follower.className = 'hero__slider-follower';
		follower.setAttribute( 'aria-hidden', 'true' );
		nav.prepend( follower );

		function positionFollower( target, isActive ) {
			   // Use offsetLeft only if nav is the offsetParent, else fallback to getBoundingClientRect
			   let left, width;
			   if (target.offsetParent === nav) {
				   left = target.offsetLeft;
				   width = target.offsetWidth;
			   } else {
				   const navRect = nav.getBoundingClientRect();
				   const targetRect = target.getBoundingClientRect();
				   left = targetRect.left - navRect.left;
				   width = targetRect.width;
			   }
			   follower.style.left  = left + 'px';
			   follower.style.width = width + 'px';
			   follower.classList.toggle( 'is-active', !! isActive );
		}

		function getActiveItem() {
			return nav.querySelector( '.hero__slider-item.is-active' );
		}

		function setWithoutTransition( fn ) {
			follower.classList.add( 'no-transition' );
			fn();
			requestAnimationFrame( () => requestAnimationFrame( () => follower.classList.remove( 'no-transition' ) ) );
		}

		setWithoutTransition( () => positionFollower( getActiveItem(), true ) );

		// Expose the active slide's label as a slug so CSS can target specific
		// slides (e.g. the physician slide gets a lighten-blend overlay).
		function syncActiveSlideAttr( item ) {
			// Lowercase, spaces → hyphens, then drop any remaining non-word
			// characters (apostrophes, ampersands, slashes) so the attribute
			// value stays clean and predictable to target in CSS.
			const slug = item ? item.textContent.trim().toLowerCase().replace( /\s+/g, '-' ).replace( /[^\w-]/g, '' ) : '';
			hero.setAttribute( 'data-active-slide', slug );
		}
		syncActiveSlideAttr( getActiveItem() ); // Reflect server-rendered index 0.

		window.addEventListener( 'resize', () => {
			setWithoutTransition( () => positionFollower( getActiveItem(), true ) );
		} );

		// ── Slide activation ───────────────────────────────────────────────

		function activateSlide( index ) {
			currentIndex = index;

			navItems.forEach( ( item, i ) => item.classList.toggle( 'is-active', i === index ) );
			slides.forEach(   ( slide, i ) => slide.classList.toggle( 'is-active', i === index ) );
			bgs.forEach(      ( bg,    i ) => bg.classList.toggle(    'is-active', i === index ) );
			positionFollower( navItems[ index ], true );
			syncActiveSlideAttr( navItems[ index ] );

			// Sync mobile nav
			mobileDots.forEach( ( dot, i ) => dot.classList.toggle( 'is-active', i === index ) );
			if ( mobileLabel && navItems[ index ] ) {
				mobileLabel.textContent = navItems[ index ].textContent.trim();
			}
		}

		// Desktop tab clicks
		navItems.forEach( ( btn, i ) => {
			btn.addEventListener( 'click', () => {
				activateSlide( i );
				resetAutoplay();
			} );
		} );

		// Mobile dot clicks
		mobileDots.forEach( ( dot ) => {
			dot.addEventListener( 'click', () => {
				const target = parseInt( dot.getAttribute( 'data-slide' ), 10 );
				activateSlide( target );
				resetAutoplay();
			} );
		} );

		// ── Autoplay ───────────────────────────────────────────────────────

		function nextSlide() {
			const next = ( currentIndex + 1 ) % slides.length;
			activateSlide( next );
		}

		function startAutoplay() {
			stopAutoplay();
			autoTimer = setInterval( nextSlide, AUTO_DELAY );
		}

		function stopAutoplay() {
			if ( autoTimer ) {
				clearInterval( autoTimer );
				autoTimer = null;
			}
		}

		function resetAutoplay() {
			startAutoplay();
		}

		if ( ! window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches ) {
			startAutoplay();
		}

		// Pause on hover (desktop slider) / touch
		hero.addEventListener( 'mouseenter', stopAutoplay );
		hero.addEventListener( 'mouseleave', startAutoplay );

		// ── Touch / swipe (mobile) ─────────────────────────────────────────

		let touchStartX = 0;
		let touchStartY = 0;
		let isSwiping   = false;

		hero.addEventListener( 'touchstart', ( e ) => {
			if ( window.innerWidth >= MOBILE_BP ) return;
			touchStartX = e.touches[ 0 ].clientX;
			touchStartY = e.touches[ 0 ].clientY;
			isSwiping   = false;
			stopAutoplay();
		}, { passive: true } );

		hero.addEventListener( 'touchmove', ( e ) => {
			if ( window.innerWidth >= MOBILE_BP ) return;
			const dx = Math.abs( e.touches[ 0 ].clientX - touchStartX );
			const dy = Math.abs( e.touches[ 0 ].clientY - touchStartY );
			if ( dx > dy && dx > 10 ) {
				isSwiping = true;
			}
		}, { passive: true } );

		hero.addEventListener( 'touchend', ( e ) => {
			if ( window.innerWidth >= MOBILE_BP || ! isSwiping ) {
				startAutoplay();
				return;
			}
			const dx = e.changedTouches[ 0 ].clientX - touchStartX;
			if ( Math.abs( dx ) > 40 ) {
				if ( dx < 0 && currentIndex < slides.length - 1 ) {
					activateSlide( currentIndex + 1 );
				} else if ( dx > 0 && currentIndex > 0 ) {
					activateSlide( currentIndex - 1 );
				}
			}
			startAutoplay();
		} );
	} );
} );
